// Imports from external sources
// React, i18next, Router, Mantine, Further Stuff
import {  
    createStyles 
} from "@mantine/core"

import { 
    DateInput
} from "@mantine/dates"
 

// Imports from vseth-canine-ui


// Imports from this projects
// Pages, Components, Features, Hooks




// Define interfaces
interface DisabledDateInputProps {
    label: string, 
    value: Date,   
}

const useStyles = createStyles((theme, _params, getRef) => {
    return {      

        DateInput: {
            backgroundColor: theme.colorScheme === 'dark' ? '#ffffff' : '#ffffff',
            color: theme.colorScheme === 'dark' ? '#000000' : '#000000',
            opacity: 1,
            cursor: 'default ',
            border: '0px solid' ,
                        
            '*:disabled': {
                backgroundColor: '#ffffff',
                color: '#000000',
                opacity: 1,
                cursor: 'default',
                border: '0px solid',
            },

        },    
    }
})


/**
 * The AdminPage component renders the admin page of the application.
 */
export const DisabledDateInput = (props: DisabledDateInputProps) => {
    const {classes, cx } = useStyles()

    return (
        <DateInput 
            className={cx(classes.DateInput)}
            label = {props.label}
            value = {props.value} 
            disabled    
            variant="unstyled"        
        />
    )
}